export default "__VITE_ASSET__9x7QB$Ty__"